import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Style from './setting.module.css';

import IntegForm from './integration_form'
import { TabPanel } from './tab-panel'

import { createMuiTheme } from '@material-ui/core/styles';
import ThemeProvider from '@material-ui/styles/ThemeProvider';




function setting(props){
  function handleChange(event: React.ChangeEvent<{}>, newValue: number) {
    props.action.setSelTab(newValue)
  }
  return(
      <div className={Style.container}>
        <ThemeProvider theme={theme}>
          <Tabs
            value={props.store.current_tab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label={props.store.tab_settings_text} />

          </Tabs>
          <TabPanel value={props.store.current_tab} index={0}>
            <SettingPanel {...props} />
          </TabPanel>
        </ThemeProvider>
      </div>
  )
}

function SettingPanel(props){
  return(
    <div>
      <IntegForm {...props}/>
    </div>
  )
}


const theme = createMuiTheme({
  palette: {
    primary: {
        main: '#3498db'
    }
  },
});


export default setting;